<template>
  <div>
    <div
      class="uk-card uk-card-default uk-card-body uk-card-small uk-card-hover pointer"
      :uk-toggle="'target: #_' + product.productId"
    >
      <img
        :src="product.productData.proofImage"
        :alt="
          product.productData.productType +
            ' proof ' +
            product.productData.proofID
        "
      />
      <h4 class="uk-margin-small">
        {{ product.productData.productType | capitalize }}
      </h4>
      <p class="uk-margin-small uk-text-break">
        Proof ID: {{ product.productData.proofID }}
      </p>
      <button class="uk-button uk-button-default uk-width-1-1 uk-margin-small">
        {{ settings.viewProductLabel }}
      </button>
    </div>

    <!-- Proof detail modal -->
    <div
      :id="'_' + product.productId"
      class="uk-modal-container"
      uk-modal
      @shown="focusDialog"
    >
      <div
        ref="dialog"
        class="uk-margin-auto-vertical uk-modal-dialog uk-modal-body"
        role="dialog"
        aria-modal="true"
        :aria-label="product.productData.productType + ' proof details'"
        tabindex="-1"
      >
        <button
          class="uk-modal-close-outside"
          type="button"
          aria-label="Close"
          uk-close
        ></button>
        <div uk-grid>
          <div class="uk-width-3-5@m uk-width-1-1">
            <img
              :src="product.productData.proofImage"
              :alt="
                product.productData.productType +
                  ' proof ' +
                  product.productData.proofID
              "
            />
          </div>
          <div class="uk-width-2-5@m uk-width-1-1">
            <div
              class="uk-card uk-card-default uk-card-body uk-width-1- uk-card-small"
            >
              <p class="uk-margin-small">
                Created
                {{
                  product.productData.created.seconds | moment("MMMM Do, YYYY")
                }}
              </p>
              <div v-if="displayNotes">
                <h4 class="uk-margin-small">
                  {{ settings.designerNotesLabel }}
                </h4>
                <ul>
                  <li
                    v-for="alert in settings.alertsCollection.items"
                    :key="alert.keyword"
                    :class="alert.keyword !== 'pantone' && 'uk-text-warning'"
                    :style="
                      (alert.keyword == 'hidden' ||
                        !product.productData.alerts[alert.keyword]) &&
                        'display: none;'
                    "
                  >
                    {{ alert.alertDescription }}
                  </li>
                  <li v-if="product.productData.customNotes">
                    {{ product.productData.customNotes }}
                  </li>
                </ul>
              </div>
              <div v-if="!showProofChangeForm">
                <button
                  class="uk-button uk-button-default uk-width-1-1"
                  v-on:click="toggleProofChangeForm()"
                  v-if="!revisionSubmitted"
                >
                  {{ settings.requestChangesLabel }}
                </button>
                <button
                  v-if="revisionSubmitted"
                  disabled
                  class="uk-button uk-button-default uk-width-1-1 uk-margin-small"
                >
                  {{ settings.requestSubmittedText }}
                </button>
                <button
                  class="uk-button uk-button-default uk-width-1-1 uk-margin-small-top"
                  v-if="
                    !swatchInCart &&
                      project.type != 'Distributor' &&
                      product.productData.productType != 'Custom Tags'
                  "
                  @click="orderSwatch()"
                >
                  {{ settings.orderSwatchLabel }}
                </button>
                <button
                  class="uk-button uk-button-default uk-width-1-1 uk-margin-small-top"
                  v-if="swatchInCart"
                  disabled
                >
                  {{ settings.swatchInCartNotice }}
                </button>
              </div>
              <div v-if="showProofChangeForm">
                <div class="uk-margin">
                  <textarea
                    class="uk-textarea"
                    rows="3"
                    placeholder="What would you like to change?"
                    aria-label="What would you like to change?"
                    v-model="revisionRequest"
                  ></textarea>
                </div>
                <div uk-grid class="uk-child-width-1-2 uk-grid-small">
                  <div>
                    <button
                      class="uk-button uk-button-default uk-width-1-1"
                      v-on:click="toggleProofChangeForm()"
                    >
                      {{ settings.cancelButtonText }}
                    </button>
                  </div>
                  <div>
                    <button
                      class="uk-button uk-button-primary uk-width-1-1"
                      @click="submitRevision()"
                    >
                      {{ settings.submitButtonText }}
                    </button>
                  </div>
                </div>
              </div>
              <ul uk-tab>
                <li>
                  <a href="#">Product</a>
                </li>
                <li v-if="standardProject">
                  <a href="#">Pricing</a>
                </li>
                <li>
                  <a href="#">Shipping</a>
                </li>
              </ul>

              <ul class="uk-switcher uk-margin">
                <li>
                  <div
                    v-if="data.productDescription"
                    v-html="data && formatContent(data.productDescription)"
                  ></div>
                </li>
                <li v-if="project.type != 'Distributor'">
                  <pricing
                    :product="product"
                    :project="project"
                    :data="data"
                    :selected-option="variantSelections"
                    :standard-pricing="standardPricing"
                    :swatch-message="settings.swatchMessage"
                    :pricing-information="
                      (data && data.pricingInformation) || null
                    "
                  ></pricing>
                </li>
                <li>
                  <p>{{ settings.shippingMessage }}</p>
                  <div
                    v-if="product.productData.productType !== 'Custom Tag'"
                    v-html="displayShippingTable(shippingContent)"
                  />
                  <p v-if="product.productData.productType == 'Custom Tag'">
                    {{ settings.customTagShippingMessage }}
                  </p>
                </li>
              </ul>
            </div>
            <div
              class="uk-card uk-card-default uk-card-body uk-width-1-1 uk-card-small uk-margin-small-top"
            >
              <div uk-grid class="uk-grid-small">
                <div v-if="data.sampleProductData" class="uk-width-1-1">
                  <div
                    v-for="option in data.sampleProductData.options"
                    :key="option.name"
                  >
                    <template
                      v-if="
                        option.name !== 'Title' &&
                          option.values[0] !== 'Default Title'
                      "
                    >
                      <h4 class="uk-margin-small">{{ option.name }}</h4>
                      <select
                        v-model="
                          variantSelections[
                            option.name.replaceAll(' ', '-').toLowerCase()
                          ]
                        "
                        :aria-label="option.name"
                        class="uk-select uk-margin-small-bottom"
                      >
                        <option
                          v-for="optionName in option.values"
                          :key="optionName"
                          :selected="option.values[0] === optionName"
                          :disabled="
                            product.productData.productType == 'Necktie' &&
                              option.name == 'Width' &&
                              optionName.indexOf('Skinny') < 0 &&
                              disableOtherWidths
                          "
                          >{{ optionName }}</option
                        >
                      </select>
                    </template>
                  </div>
                </div>
              </div>
              <div class="uk-width-1-2">
                <h4 class="uk-margin-small uk-text-bottom">Quantity</h4>
              </div>
              <div class="uk-width-1-2">
                <div>
                  <input
                    class="uk-input"
                    type="number"
                    min="0"
                    aria-label="Quantity"
                    onKeyPress="if(this.value.length==4) return false;"
                    v-model.number="quantity"
                  />
                </div>
              </div>
              <div class="uk-width-1-1" v-if="project.type != 'Distributor'">
                <h4 class="uk-text-right uk-margin-small-bottom">
                  {{ displayPrice | money }} each
                </h4>
                <p class="uk-margin-small uk-text-right">
                  {{ settings.bulkQuantityInstructions }}
                </p>
                <p class="uk-margin-small uk-text-right">
                  {{
                    project.type == "Distributor"
                      ? settings.bulkPriceDistributor
                      : settings.bulkPriceRegular
                  }}
                </p>
              </div>
              <div class="uk-width-1-1">
                <button
                  :disabled="quantity == 0 || !minimumMet"
                  class="uk-button uk-button-primary uk-width-1-1 uk-margin-small-top"
                  @click="addToCart()"
                >
                  {{
                    project.type == "Distributor"
                      ? settings.addToCartDistributor
                      : settings.addToCartRegular
                  }}
                  <span v-if="!minimumMet">{{ settings.minimumText }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import CrmService from "@/services/CrmService";
import Pricing from "@/components/design-portal/Pricing.vue";
import ProjectsService from "@/services/ProjectsService";

export default {
  name: "ProductView",
  components: {
    pricing: Pricing
  },
  data() {
    return {
      showProofChangeForm: false,
      variantSelections: {},
      quantity: 0,
      revisionRequest: "",
      revisionSubmitted: false,
      kidsLengthSelected: false,
      disableOtherWidths: false,
      shopifyProductDataV2: {}
    };
  },
  methods: {
    focusDialog(event) {
      if (event.target === event.currentTarget) {
        this.$refs.dialog.focus();
      }
    },
    displayShippingTable(content) {
      return atob(content);
    },
    toggleProofChangeForm() {
      if (this.showProofChangeForm) {
        this.showProofChangeForm = false;
      } else {
        this.showProofChangeForm = true;
      }
    },
    optionCheck() {
      if (this.data.productType == "Necktie") {
        if (this.variantSelections.length.indexOf("Kids") > -1) {
          // prettier-ignore
          this.variantSelections.width = 'Skinny 2.25\"';
        }
      }
    },
    addToCart() {
      var item = _.cloneDeep(this.cartItem);
      this.$emit("add-to-cart", item);
      UIkit.modal("#_" + this.product.productId).hide();
    },
    orderSwatch() {
      this.$emit("order-swatch", this.swatchItem);
    },
    submitRevision() {
      var self = this;
      let revision = {
        dealID: self.project.projectID,
        proofID: self.product.productData.proofID,
        note: self.revisionRequest
      };
      CrmService.revisionRequest(revision);
      self.toggleProofChangeForm();
      this.revisionSubmitted = true;
      setTimeout(function() {
        self.revisionSubmitted = false;
      }, 2000);
    },
    formatContent(content) {
      var newContent = document.createElement("div");
      for (const block of content.json.content) {
        if (block.nodeType == "paragraph") {
          let text = document.createElement("p");
          for (content in block.content) {
            text.innerHTML += block.content[content].value.replaceAll(
              "\n",
              "<br />"
            );
          }

          newContent.appendChild(text);
        }
        if (block.nodeType == "text") {
          let text = document.createElement("span");
          text.innerText = block.value;
          newContent.appendChild(text);
        }
        if (block.nodeType == "hyperlink") {
          let link = document.createElement("a");
          link.href = block.data.uri;
          link.innerText = block.content[0].value;
          newContent.appendChild(link);
        }
      }
      return newContent.innerHTML;
    }
  },
  computed: {
    displayPrice() {
      const type = this.product.productData.productType;
      if (this.data.customPricing) {
        var v = "";
        var option = "";
        const productOptions = this.data.sampleProductData.options;
        const options = this.data.variantMapping;

        for (const option of productOptions) {
          v += this.variantSelections[_.camelCase(option.name)];
          if (productOptions.indexOf(option) !== productOptions.length - 1) {
            v += " / ";
          }
        }
        const arr = options && options.filter(vv => vv.name == v);
        option = arr.length && arr[0].firebaseId;
        option = option.charAt(0).toUpperCase() + option.slice(1);

        if (option) {
          return this.pricingInfo.unitPrice[
            `${_.camelCase(type)}${option.replaceAll('"', "")}`
          ];
        } else {
          return this.pricingInfo.unitPrice[_.camelCase(type)];
        }
      } else {
        return this.pricingInfo.unitPrice[_.camelCase(type)];
      }
    },
    cartItem() {
      const self = this;

      let fileNameNoLocation = this.product.productData.proofImage.substring(
        this.product.productData.proofImage.indexOf("%2F") + 3
      );
      const object = {
        fileName: fileNameNoLocation.substring(
          0,
          fileNameNoLocation.indexOf("?")
        ),
        productData: this.product.productData,
        quantity: this.quantity,
        variantSelections: this.variantSelections,
        productCategory: self.shopifyProductDataV2.category.id
      };
      return object;
    },
    swatchItem() {
      const object = {
        proofImage: this.product.productData.proofImage,
        productType: this.product.productData.productType,
        proofID: this.product.productData.proofID
      };
      return object;
    },
    swatchInCart() {
      for (let index = 0; index < this.project.swatches.length; index++) {
        const element = this.project.swatches[index];
        if (this.product.productData.proofID == element.proofID) {
          return true;
        }
      }
      return false;
    },
    displayNotes() {
      if (
        this.product.productData.alerts.thinLines ||
        this.product.productData.alerts.lowContrast ||
        this.product.productData.alerts.lowRes ||
        this.product.productData.alerts.pantone ||
        this.product.productData.customNotes
      ) {
        return true;
      }
    },
    minimumMet() {
      return this.quantity >= this.data.minimumQuantity;
    },
    itemVariants() {
      if (this.data && this.data.data) {
        const variants = [];
        for (const option of this.data.data.options) {
          variants.push({
            name: option.name,
            values: option.values
          });
        }
        return variants;
      }
      return false;
    }
  },
  watch: {
    quantity: function() {
      let impliedQty = 1;
      if (this.quantity === "") {
        impliedQty = 0;
      } else {
        impliedQty = this.quantity;
      }
      let type = this.product.productData.productType;
      let variantSelections = this.variantSelections;
      var option = null;
      if (this.data.customPricing) {
        const arr =
          this.data.variantMapping &&
          this.data.variantMapping.filter(
            v => v.name == Object.values(variantSelections)[0]
          );
        option = arr.length && arr[0].firebaseId;
      }
      let arr = [impliedQty, type, variantSelections, option];
      this.$emit("qty-change", arr);
    },
    "variantSelections.width"(newSelection) {
      if (
        this.product &&
        this.product.productData &&
        this.product.productData.productType == "Necktie"
      ) {
        this.kidsLengthSelected =
          this.variantSelections.length.indexOf("Kids") > -1;
        if (this.kidsLengthSelected) {
          this.variantSelections.width = 'Skinny 2.25"';
          this.disableOtherWidths = true;
        } else {
          this.disableOtherWidths = false;
        }
      }
    },
    "variantSelections.length"(newSelection) {
      if (
        this.product &&
        this.product.productData &&
        this.product.productData.productType == "Necktie"
      ) {
        this.kidsLengthSelected = newSelection.indexOf("Kids") > -1;
        if (this.kidsLengthSelected) {
          this.variantSelections.width = 'Skinny 2.25"';
          this.disableOtherWidths = true;
        } else {
          this.disableOtherWidths = false;
        }
      }
    }
  },
  async created() {
    if (this.data.sampleProductData.options) {
      for (const option of this.data.sampleProductData.options) {
        this.$set(
          this.variantSelections,
          option.name.toLowerCase(),
          option.values[0]
        );
      }
    }
    if (this.data.sampleProduct) {
      const shopifyData = await ProjectsService.getProductById({
        id: atob(this.data.sampleProduct)
      }).then(response => {
        return response;
      });
      this.shopifyProductDataV2 = shopifyData.data;
    }
  },
  async mounted() {
    var self = this;
    let type = self.product.productData.productType;
    UIkit.util.on(document, "hide", "#_" + this.product.productId, function() {
      var option = "";
      const options = self.variantSelections;
      if (self.data.customPricing) {
        var v = "";
        if (options) {
          if (Object.keys(options).length > 1) {
            for (const value of Object.values(options)) {
              v += value;
              if (
                Object.values(options).indexOf(value) !==
                Object.values(options).length - 1
              ) {
                v += " / ";
              }
            }
          } else {
            v += Object.values(options)[0];
          }
        }
        const arr =
          self.data.variantMapping &&
          self.data.variantMapping.filter(vv => vv.name == v);
        option = arr.length && arr[0].firebaseId;
      }
      let arr = [self.quantity, type, options, option];
      self.$emit("qty-change", arr);
      self.quantity = "";
    });
    UIkit.util.on(document, "show", "#_" + this.product.productId, function() {
      self.quantity = 0;
    });
  },
  props: [
    "product",
    "pricingInfo",
    "project",
    "standardPricing",
    "data",
    "settings",
    "shippingContent",
    "standardProject"
  ],
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      return _.startCase(value);
    },
    money: function(value) {
      if (!value) return "";
      if (value == "-") return "$ –";
      return "$" + Number(value).toFixed(2);
    }
  }
};
</script>

<style type="text/css">
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/design-portal/ProductView.vue